module.exports = __webpack_public_path__ + "static/el-capitain-22849d126e0cecec737979e97aa2b0a4.jpg";